import { sanitizePortalHTMLContent } from "@tellescope/utils";
import { getFieldDescriptionType } from "./utils";

export interface FieldDescriptionProps {
  description?: string;
  htmlDescription?: string;
}

export const FieldDescription = (props: FieldDescriptionProps) => {
  const descriptionType = getFieldDescriptionType(props);

  switch (descriptionType) {
    case "description":
      return <p className="text-muted-foreground text-sm">{props.description}</p>;
    case "htmlDescription":
      return (
        <div
          className="prose prose-sm max-w-none [&>p]:text-xs [&>p]:text-muted-foreground"
          dangerouslySetInnerHTML={{ __html: sanitizePortalHTMLContent(props.htmlDescription ?? "", "user") }}
        />
      );
    case undefined:
      return null;
  }
};
